import { render, staticRenderFns } from "./SelectedDoctors.vue?vue&type=template&id=5a3df768&scoped=true"
import script from "./SelectedDoctors.vue?vue&type=script&lang=js"
export * from "./SelectedDoctors.vue?vue&type=script&lang=js"
import style0 from "./SelectedDoctors.vue?vue&type=style&index=0&id=5a3df768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3df768",
  null
  
)

export default component.exports